// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Research Share Page - Overrides for printable view */
/* Uses research-dashboard.css as base */

/* Page container */
.share-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 40px;
  background: white;
  min-height: 100vh;
}

/* Share page header */
.share-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.share-logo img {
  height: 28px;
}

.share-meta {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: #9ca3af;
}

/* Title section override */
.share-page .share-title-section {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

/* Print actions */
.share-actions {
  display: flex;
  justify-content: center;
  padding: 32px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  margin-top: 40px;
}

/* Ensure questions are always expanded on share page */
.share-page .question-result-content {
  max-height: none !important;
  overflow: visible !important;
}

/* Hide expand icon on share page */
.share-page .expand-icon {
  display: none;
}

/* Remove hover cursor from question header */
.share-page .question-result-header {
  cursor: default;
}

.share-page .question-result-header:hover {
  background: transparent;
}

/* Print styles */
@media print {
  .share-page {
    padding: 16px 24px;
    max-width: 100%;
  }

  .share-actions {
    display: none !important;
  }

  .share-header {
    border-bottom-color: #e5e7eb;
  }

  /* Force horizontal layout for question charts */
  .share-page .question-charts-row {
    display: flex !important;
    flex-direction: row !important;
    gap: 24px !important;
  }

  .share-page .question-pie-section {
    flex: 0 0 200px !important;
    min-width: 200px !important;
  }

  .share-page .question-breakdown-section {
    flex: 1 1 !important;
    min-width: 0 !important;
  }

  /* Stacked bar chart adjustments for print */
  .share-page .stacked-bar-chart {
    display: flex !important;
    gap: 8px !important;
  }

  .share-page .stacked-bars {
    display: flex !important;
    gap: 8px !important;
    flex: 1 1 !important;
  }

  .share-page .stacked-bar-column {
    flex: 1 1 !important;
  }

  .share-page .stacked-bar {
    height: 140px !important;
  }

  .share-page .stacked-bar-axis {
    height: 140px !important;
  }

  /* Demographics grid - keep horizontal */
  .share-page .demographics-grid {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 16px !important;
  }

  .share-page .donut-chart-container {
    flex: 1 1 30% !important;
    min-width: 200px !important;
  }

  /* Page breaks */
  .dashboard-section {
    page-break-inside: avoid;
  }

  .question-result-card {
    page-break-inside: avoid;
    margin-bottom: 16px !important;
  }

  /* Preserve colors */
  .dashboard-status,
  .progress-bar-fill,
  .donut-segment,
  .pie-segment,
  .stacked-bar-segment,
  .legend-color,
  .donut-legend-color,
  .question-number,
  .horizontal-bar-fill {
    print-color-adjust: exact;
  }

  /* Disable animations */
  .donut-segment,
  .pie-segment,
  .stacked-bar-segment {
    animation: none !important;
    opacity: 1 !important;
  }

  /* Progress section - ensure gradient shows */
  .progress-current {
    color: #FF6B4A !important;
    -webkit-text-fill-color: #FF6B4A !important;
    print-color-adjust: exact;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .share-page {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/research-share.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD,wCAAwC;;AAIxC,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA,gDAAgD;EAChD;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,oBAAkB;IAClB,uBAAuB;EACzB;;EAEA,4CAA4C;EAC5C;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,oBAAkB;EACpB;;EAEA;IACE,oBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,wCAAwC;EACxC;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA,gBAAgB;EAChB;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA,oBAAoB;EACpB;;;;;;;;;IAUE,yBAAyB;EAC3B;;EAEA,uBAAuB;EACvB;;;IAGE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA,6CAA6C;EAC7C;IACE,yBAAyB;IACzB,2CAA2C;IAE3C,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Research Share Page - Overrides for printable view */\n/* Uses research-dashboard.css as base */\n\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');\n\n/* Page container */\n.share-page {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 32px 40px;\n  background: white;\n  min-height: 100vh;\n}\n\n/* Share page header */\n.share-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  margin-bottom: 24px;\n}\n\n.share-logo img {\n  height: 28px;\n}\n\n.share-meta {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n/* Title section override */\n.share-page .share-title-section {\n  border-bottom: none;\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n\n/* Print actions */\n.share-actions {\n  display: flex;\n  justify-content: center;\n  padding: 32px 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n  margin-top: 40px;\n}\n\n/* Ensure questions are always expanded on share page */\n.share-page .question-result-content {\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n/* Hide expand icon on share page */\n.share-page .expand-icon {\n  display: none;\n}\n\n/* Remove hover cursor from question header */\n.share-page .question-result-header {\n  cursor: default;\n}\n\n.share-page .question-result-header:hover {\n  background: transparent;\n}\n\n/* Print styles */\n@media print {\n  .share-page {\n    padding: 16px 24px;\n    max-width: 100%;\n  }\n\n  .share-actions {\n    display: none !important;\n  }\n\n  .share-header {\n    border-bottom-color: #e5e7eb;\n  }\n\n  /* Force horizontal layout for question charts */\n  .share-page .question-charts-row {\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 24px !important;\n  }\n\n  .share-page .question-pie-section {\n    flex: 0 0 200px !important;\n    min-width: 200px !important;\n  }\n\n  .share-page .question-breakdown-section {\n    flex: 1 !important;\n    min-width: 0 !important;\n  }\n\n  /* Stacked bar chart adjustments for print */\n  .share-page .stacked-bar-chart {\n    display: flex !important;\n    gap: 8px !important;\n  }\n\n  .share-page .stacked-bars {\n    display: flex !important;\n    gap: 8px !important;\n    flex: 1 !important;\n  }\n\n  .share-page .stacked-bar-column {\n    flex: 1 !important;\n  }\n\n  .share-page .stacked-bar {\n    height: 140px !important;\n  }\n\n  .share-page .stacked-bar-axis {\n    height: 140px !important;\n  }\n\n  /* Demographics grid - keep horizontal */\n  .share-page .demographics-grid {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    gap: 16px !important;\n  }\n\n  .share-page .donut-chart-container {\n    flex: 1 1 30% !important;\n    min-width: 200px !important;\n  }\n\n  /* Page breaks */\n  .dashboard-section {\n    page-break-inside: avoid;\n  }\n\n  .question-result-card {\n    page-break-inside: avoid;\n    margin-bottom: 16px !important;\n  }\n\n  /* Preserve colors */\n  .dashboard-status,\n  .progress-bar-fill,\n  .donut-segment,\n  .pie-segment,\n  .stacked-bar-segment,\n  .legend-color,\n  .donut-legend-color,\n  .question-number,\n  .horizontal-bar-fill {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  /* Disable animations */\n  .donut-segment,\n  .pie-segment,\n  .stacked-bar-segment {\n    animation: none !important;\n    opacity: 1 !important;\n  }\n\n  /* Progress section - ensure gradient shows */\n  .progress-current {\n    color: #FF6B4A !important;\n    -webkit-text-fill-color: #FF6B4A !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .share-page {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
